/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import DatePicker from "react-datepicker";
import { Trash2, Edit } from "react-feather";
import moment from "moment";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { LabSelect } from "../../course/select";
import { calcularFechaHabil } from "../../../pages/NotasDePedido/utils";
import MotivoNoAvanzaFormModal from "../MotivoNoAvanzaModal";
import { CustomLabel } from "../../../ui/labels";
import { InputText, InputTextArea } from "../../../ui/inputs";
import { ButtonPrimary } from "../../../ui/buttons";
import { GridGroup } from "../styles";
import { formatearFecha, getMotivoNoAvanza } from "../utils";

// enum ESTADOS CANDIDATO
// Reclutando Preventivamente = 1,
// Reclutando = 2,
// Derivado = 3,
// Pre Ingreso = 4,
// Ingreso = 5,
// No Avanza = 6

const FormEditCandidato = ({
  toggle,
  info,
  canCreateOV,
  createdAt,
  formik,
  handleReactSelectChange,
  provinciaValue,
  isLoadingCategoies,
  provinciaOptions,
  ciudadOptions,
  ciudadValue,
  isLoadingCiudades,
  portalValue,
  portalesOptions,
  estadoValue,
  estadosOptionsFiltered,
  motivoValue,
  motivo,
  motivoOtroValue,
  motivoOtro,
  setShowMotivoNoAvanzaModal,
  showMotivoNoAvanzaModal,
  handleMotivoNoAvanza,
  motivos,
  showFechaDeIngreso,
  handleDatesChange,
  fechaDeIngresoValue,
  fechaActual,
  handleFileChange,
  fileName,
  handleDeleteCV,
}) => {
  return (
    <>
      <div style={{ width: "90%", margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
          <GridGroup className="mb-3">
            <div style={{ height: "40px" }}>
              <CustomLabel className=" pt-0 w-100">
                Fecha de creación:
                <p className="form-control border-0 m-0">{moment(createdAt).format("DD/MM/YYYY")}</p>
              </CustomLabel>
            </div>

            <div>
              <CustomLabel htmlFor="nombre" className=" pt-0 w-100">
                Nombre
                <InputText
                  className="w-100 "
                  // type="number"
                  name="nombre"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nombre}
                />
              </CustomLabel>
            </div>

            <div>
              <CustomLabel htmlFor="apellido" className=" pt-0 w-100">
                Apellido
                <InputText
                  className="w-100 "
                  // type="number"
                  name="apellido"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.apellido}
                />
              </CustomLabel>
            </div>

            <div>
              <CustomLabel htmlFor="email" className=" pt-0 w-100">
                Email
                <InputText
                  className="w-100 "
                  type="email"
                  name="email"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  style={formik.touched.email && formik.errors.email ? { borderBottom: "1px solid red" } : null}
                />
                {formik.touched.email && formik.errors.email ? <CustomLabel style={{ color: "red" }}>{formik.errors.email}</CustomLabel> : null}
              </CustomLabel>
            </div>

            <div>
              <CustomLabel htmlFor="telefono" className=" pt-0 w-100">
                Teléfono
                <InputText
                  className="w-100 "
                  type="number"
                  name="telefono"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onWheel={(e) => e.target.blur()}
                  value={formik.values.telefono}
                />
              </CustomLabel>
            </div>

            <div>
              <CustomLabel htmlFor="cuil" className=" pt-0 w-100">
                Cuil
                <InputText
                  className="w-100"
                  type="number"
                  name="cuil"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onWheel={(e) => e.target.blur()}
                  value={formik.values.cuil}
                />
              </CustomLabel>
            </div>

            <div className="mb-1">
              <CustomLabel>Provincia</CustomLabel>
              <LabSelect
                id="provincia"
                name="provincia"
                className="w-100"
                onChange={handleReactSelectChange}
                value={provinciaValue}
                placeholder="Seleccionar"
                isClearable
                isLoading={isLoadingCategoies}
                disabled={isLoadingCategoies || formik.isSubmitting}
                options={provinciaOptions}
              />
            </div>

            <div className="mb-1">
              <CustomLabel>Ciudad</CustomLabel>
              <LabSelect
                id="ciudad"
                name="ciudad"
                className="w-100"
                onChange={handleReactSelectChange}
                value={ciudadValue}
                placeholder="Seleccionar"
                isClearable
                isLoading={isLoadingCiudades || formik.isSubmitting || isLoadingCategoies}
                isDisabled={ciudadOptions && ciudadOptions.length === 0}
                options={ciudadOptions}
              />
            </div>

            <div>
              <CustomLabel htmlFor="portal" className=" pt-0 w-100">
                Portal
                <LabSelect
                  id="portal"
                  name="portal"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={portalValue}
                  placeholder="Seleccionar..."
                  isClearable
                  isLoading={isLoadingCategoies}
                  isDisabled={isLoadingCategoies}
                  options={portalesOptions}
                />
              </CustomLabel>
            </div>

            <div>
              <CustomLabel htmlFor="estado" className="pt-0 w-100">
                Estado
                <LabSelect
                  id="estado"
                  name="estado"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={estadoValue}
                  // isClearable
                  isLoading={isLoadingCategoies}
                  isDisabled={isLoadingCategoies}
                  options={estadosOptionsFiltered}
                />
                {(motivoValue || motivo) && estadoValue.value === 6 && (
                  <div>
                    <CustomLabel htmlFor="motivo">{getMotivoNoAvanza(motivoValue || motivo, motivos, motivoOtroValue || motivoOtro)}</CustomLabel>
                    <Button size="xs" color="link" onClick={() => setShowMotivoNoAvanzaModal(!showMotivoNoAvanzaModal)}>
                      <Edit size="14" color="#293134" />
                    </Button>
                  </div>
                )}
              </CustomLabel>
            </div>

            {showMotivoNoAvanzaModal && (
              <MotivoNoAvanzaFormModal
                handleMotivoNoAvanza={handleMotivoNoAvanza}
                isOpen={showMotivoNoAvanzaModal}
                toggle={() => setShowMotivoNoAvanzaModal(!showMotivoNoAvanzaModal)}
                info={info}
              />
            )}
            {showFechaDeIngreso && (
              <div>
                <StylesDatePicker className="mb-1">
                  <CustomLabel htmlFor="fechaAbierta" className=" pt-0 w-100">
                    Fecha de ingreso
                    <DatePicker
                      className="date-input digits w-100"
                      dateFormat="AAAA-MM-dd"
                      onChange={handleDatesChange}
                      disabled={formik.isSubmitting}
                      value={formatearFecha(fechaDeIngresoValue)}
                      selected={fechaDeIngresoValue ? new Date(fechaDeIngresoValue).setDate(new Date(fechaDeIngresoValue).getDate() + 1) : null}
                      minDate={new Date(calcularFechaHabil(fechaActual, -1))}
                    />
                  </CustomLabel>
                </StylesDatePicker>
              </div>
            )}
          </GridGroup>
          {canCreateOV && estadoValue && estadoValue.value === 5 && (
            <CustomLabel htmlFor="estado" className="p-2 mb-3 w-100" style={{ border: "1px solid red", borderRadius: "4px", fontWeight: "bold" }}>
              La Nota de Pedido pasará automáticamente a cubierta si se completan las vacantes. No se olvide de tener en estado Facturado la Orden de Venta primero.
            </CustomLabel>
          )}

          <div className="mb-3">
            <CustomLabel htmlFor="observaciones" className=" pt-0 w-100">
              Comentarios
              <InputTextArea
                className="w-100 "
                type="observaciones"
                name="observaciones"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.observaciones}
              />
            </CustomLabel>
          </div>
          <div className="mb-3">
            <CustomLabel htmlFor="apellido" className="pt-0 w-100">
              Cargar CV
              <div className="d-flex align-items-center">
                <div className="custom-file">
                  <input
                    className="custom-file-input"
                    type="file"
                    id="upfile"
                    onChange={handleFileChange}
                    accept=".pdf, .xls, .xlsx, .doc, .docx, .jpg, .jpeg, .png"
                    style={{ cursor: "pointer", border: "none" }}
                    disabled={formik.isSubmitting}
                  />
                  <label className="custom-file-label" htmlFor="upfile">
                    {fileName}
                  </label>
                </div>
                <UncontrolledTooltip placement="top" target="deleteCV">
                  Eliminar
                </UncontrolledTooltip>
                <Button size="xs" color="link" id="deleteCV" onClick={handleDeleteCV}>
                  <Trash2 size={18} className="ml-2" color="#293134" />
                </Button>
              </div>
            </CustomLabel>
          </div>
        </div>

        <div className="mt-3 mb-0 d-flex justify-content-end" style={{ paddingTop: "10px", borderTop: "1px solid #CCCCCC" }}>
          <Button color="btn-secondary mr-2" onClick={toggle}>
            Cancelar
          </Button>
          <ButtonPrimary isLoading={formik.isSubmitting} disabled={formik.isSubmitting} type="button" onClick={formik.handleSubmit}>
            Guardar
          </ButtonPrimary>
        </div>
      </div>
    </>
  );
};

export default FormEditCandidato;
